export enum QueryKeys {
  tollingAdminAccess = 'tollingAdminAccess',

  billingDetailsList = 'billingDetailsList',
  billingDetailsInfo = 'billingDetailsInfo',

  agreementLineList = 'agreementLineList',
  agreementLineInfo = 'agreementLineInfo',

  tollDeclarationsList = 'tollDeclarationsList',
  tollDeclarationInfo = 'tollDeclarationInfo',

  paymentClaimsList = 'paymentClaimsList',
  paymentClaimInfo = 'paymentClaimInfo',

  obeEventLog = 'obeEventLog',
  obeKapschEventLog = 'obeKapschEventLog',

  obeList = 'obeList',
  obeDetails = 'obeDetails',

  assetManagementList = 'assetManagementList',
  assetManagementDetails = 'assetManagementDetails',

  efcContextMarksList = 'efcContextMarksList',
  efcContextMarkDetails = 'efcContextMarkDetails',

  efcContextDataInboundList = 'efcContextDataInboundList',
  efcContextDataOutboundList = 'efcContextDataOutboundList',

  auditLog = 'auditLog',

  exceptionLists = 'exceptionLists',
  exceptionListDetails = 'exceptionListDetails',
  exceptionListChunks = 'exceptionListChunks',

  tollChargersList = 'tollChargersList',
  tollChargerDetails = 'tollChargerDetails',

  contractIssuerList = 'contractIssuerList',
  contractIssuerDetails = 'contractIssuerDetails',

  transactionsList = 'transactionsList',
  transactionsDetails = 'transactionsDetails',

  abnormalBehaviorReportList = 'abnormalBehaviorReportList',
  abnormalBehaviorReportDetails = 'abnormalBehaviorReportDetails',

  oresundPayData = 'oresundPayData',

  acceptedObjectsData = 'acceptedObjectsData',

  inboundStatusAduList = 'inboundStatusAduList',
}
